import { configureCommonImports } from "@/plugins/commonImports";
import vuetify from "@/plugins/vuetify";

// This must go after importing vuetify/vue
import "@/sass/main.sass";

// Main imports
import router, { configureRouterForBm } from "@/router/router";
import "@/plugins/vueCharts";
import "@/plugins/googleApis";
import BrewManApp from "@/components/App.vue";
import TradePortalApp from "@tp/App.vue";

// Application-wide initialisation
import userStore from "@/store/modules/userStore";
import tasksStore from "@/store/modules/tasksStore";
import "@/store/modules/dutyConfigurationStore";
import "@/store/modules/invoiceConfigurationStore";
import api from "@/app/api";
import {
  transformErrorInterceptor,
  transformRequestRttInterceptor,
} from "@/app/apiInterceptors";
import devtoolsPlugin from "@/plugins/devToolsPlugin";
import { errorCaptured } from "@/plugins/vueErrorHandler";
import { configureRouterForTp } from "@tp/router";
import integrationErrorStore from "./store/modules/integrationErrorStore";
import Vue from "vue";
import { i18nCore } from "@/vue23switching/i18nCoreWrap";
import type { MessagesWithKeys } from "@/plugins/i18n";
import messages, { translate } from "@/plugins/i18n";

configureCommonImports();

// I18n - Set up for Vue 2
Vue.prototype.$m = messages as MessagesWithKeys;
Vue.prototype.$t = translate;

// Originally tried to make TP run with its own entry point index.html
// This worked in Dev but could not get it to work on Staging / Production
// Presumably something deep in Vite Config needed to make it work
// So now we just leave the site entry as the BrewMan index.html
// and manually switch here to either BM or TP.

const brewManStartup = async () => {
  await userStore.load();
  await tasksStore.startAutoRefresh();
  await integrationErrorStore.startAutoRefresh();

  // Need to initialize the store before create the Vue instance as the router guards will be called and they need store
  // state

  Vue.use(devtoolsPlugin);

  // Expose router to Cypress if running Cypress
  if ((window as any).Cypress) {
    (window as any).router = router;
  }

  const app = new Vue({
    vuetify,
    router,
    i18n: i18nCore.i18n,
    render: (h) => h(BrewManApp),
    errorCaptured,
    // @ts-expect-error - This is a Vue 2.x option to globally set the mixin
    // https://devtools.vuejs.org/plugin/plugins-guide.html#vue-2
    devtoolsPlugin: true,
  }).$mount("#app");
};

const tradePortalStartup = async () => {
  await userStore.load();
  // Need to initialize the store before create the Vue instance as the router guards will be called and they need store
  // state

  Vue.use(devtoolsPlugin);

  const app = new Vue({
    vuetify,
    router,
    i18n: i18nCore.i18n,
    render: (h) => h(TradePortalApp),
    errorCaptured,
    // @ts-expect-error - This is a Vue 2.x option to globally set the mixin
    // https://devtools.vuejs.org/plugin/plugins-guide.html#vue-2
    devtoolsPlugin: true,
  }).$mount("#app");
};

if (window.location.pathname.toLowerCase().startsWith("/tradeportal")) {
  configureRouterForTp();

  api.responseInterceptors = [
    transformErrorInterceptor,
    transformRequestRttInterceptor,
  ];
  tradePortalStartup();
} else {
  // Not Hit a Trade Portal URL - run BrewMan
  configureRouterForBm();

  api.responseInterceptors = [
    transformErrorInterceptor,
    transformRequestRttInterceptor,
  ];
  brewManStartup();
}
